const SORT_DEFAULT = '-';
export default SORT_DEFAULT;